import React, {
  Dispatch,
  ReactNode,
  createContext,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import { propertyTableRowsReducer } from './reducer';
import { TableHeader, RowData, TableState, RowsAction } from '../index';

const PropertyTableContext = createContext<TableState | null>(null);
const PropertyTableDispatchContext = createContext<Dispatch<RowsAction> | null>(
  null
);

interface PropertyTableProviderProps {
  children: ReactNode;
  headers: TableHeader[];
  initialRows: RowData[];
}

export function PropertyTableProvider({
  children,
  headers: headersProps,
  initialRows,
}: PropertyTableProviderProps) {
  const headers = useMemo(() => headersProps, [headersProps]);
  const [state, dispatch] = useReducer(propertyTableRowsReducer, {
    rows: initialRows || [],
  });

  const { rows } = state;
  return (
    <PropertyTableContext.Provider value={{ headers, rows }}>
      <PropertyTableDispatchContext.Provider value={dispatch}>
        {children}
      </PropertyTableDispatchContext.Provider>
    </PropertyTableContext.Provider>
  );
}

export function useTableRows() {
  const context = useContext(PropertyTableContext);
  if (context === null) {
    throw new Error('useTableRows must be used within a PropertyTableProvider');
  }
  return context;
}

export function useTableRowsDispatch() {
  const context = useContext(PropertyTableDispatchContext);
  if (context === null) {
    throw new Error(
      'useTableRowsDispatch must be used within a PropertyTableProvider'
    );
  }
  return context;
}
